// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kBMB","footer":"styles_footer__248aY"};